import { FEATURE_FLAGS } from '@highlight/analytics'
import { useFlags } from '@highlight/analytics/react'

/** Reveal the trailing answer text while it streams instead of after the turn ends. */
export function useIsLiveFinalRevealEnabled(): boolean {
  return useFlags().isEnabled(FEATURE_FLAGS.CHAT_LIVE_FINAL_REVEAL, false)
}
